import {
  isScholarshipStatusId as orgIsScholarshipStatusId,
  scholarshipStatusList as orgScholarshipStatusList,
  defaultScholarshipStatus as orgDefaultScholarshipStatus,
  isScholarshipTypeId as orgIsScholarshipTypeId,
  scholarshipTypeList as orgScholarshipTypeList,
  defaultScholarshipType as orgDefaultScholarshipType,
  isBorrowingPeriodId as orgIsBorrowingPeriodId,
  borrowingPeriodList as orgBorrowingPeriodList,
  defaultBorrowingPeriod as orgDefaultBorrowingPeriod,
  type ScholarshipStatusId as OrgScholarshipStatusId,
  type ScholarshipTypeId as OrgScholarshipTypeId,
  type BorrowingPeriodId as OrgBorrowingPeriodId,
} from '@/packages/nurse-senka-frontend-sdk';

// 奨学金借入状況
export type ScholarshipStatusId = OrgScholarshipStatusId;

export const isScholarshipStatusId = orgIsScholarshipStatusId;

export const scholarshipStatusList = orgScholarshipStatusList;

export const defaultScholarshipStatus = orgDefaultScholarshipStatus;

// 奨学金種別
export type ScholarshipTypeId = OrgScholarshipTypeId;

export const isScholarshipTypeId = orgIsScholarshipTypeId;

export const scholarshipTypeList = orgScholarshipTypeList;

export const defaultScholarshipType = orgDefaultScholarshipType;

// 奨学金借入（予定）年数
export type BorrowingPeriodId = OrgBorrowingPeriodId;

export const isBorrowingPeriodId = orgIsBorrowingPeriodId;

export const borrowingPeriodList = orgBorrowingPeriodList;

// eslint-disable-next-line no-magic-numbers, prefer-destructuring
export const defaultBorrowingPeriod = orgDefaultBorrowingPeriod;
